import { gql } from '@apollo/client';
import type { GetRemoveTopicDisabledMessage_TopicFragment } from '../../graphql/generated/graphqlTypes';
import topicPolicyCheck, {
  getTopicPolicyRequirement,
  MinimalRoleLevel,
  TopicPolicyAction,
} from '../../topic/topicPolicyCheck';

const TOPIC_FRAGMENT = gql`
  fragment getRemoveTopicDisabledMessage_topic on Topic {
    id
    ...topicPolicyCheck_topic
  }
  ${topicPolicyCheck.fragments.topic}
`;

const REMOVE_DISABLED_MESSAGE: Record<MinimalRoleLevel, string | undefined> = {
  [MinimalRoleLevel.None]: undefined,
  [MinimalRoleLevel.Member]: 'You must be a topic member to remove this topic.',
  [MinimalRoleLevel.Owner]: 'You must be a topic owner to remove this topic.',
  [MinimalRoleLevel.Never]: 'You cannot remove this topic.',
};

export default function getRemoveTopicDisabledMessage(
  topic: GetRemoveTopicDisabledMessage_TopicFragment,
  user: Parameters<typeof topicPolicyCheck>[2],
) {
  const requiredLevel =
    !topicPolicyCheck(TopicPolicyAction.EditPost, topic, user) &&
    getTopicPolicyRequirement(TopicPolicyAction.EditPost, topic, user);

  return requiredLevel ? REMOVE_DISABLED_MESSAGE[requiredLevel] : undefined;
}

getRemoveTopicDisabledMessage.fragments = {
  topic: TOPIC_FRAGMENT,
};
